import React, { useEffect, useState } from "react";
import SendMailIcon from "assets/svgIcons/SendMailIcon";
import EditIcon from "assets/svgIcons/EditSqrIcon";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import CloseIcon from "assets/svgIcons/CrossIconWithCircle";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import Checkbox from "@mui/material/Checkbox";
// modal
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { PopUpContainer } from "assets/css/globle";
import { StyledCheckbox } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { TableContainer } from "pages/Messages/Notifications/NotificationsStyled";
import { StyledTable } from "assets/css/globle";
// global data
import { NOTIFICATION_GLOBAL_STATES } from "../../../../globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
// comman services and global store
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isUserBasic, isUserReadOnly } from "constant";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "400px",
  width: "calc(100% -  40px)",
  bgcolor: "background.paper",
  borderRadius: "5px",
  overflow: "hidden",
};

const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "200px",
  width: "calc(100% -  70px)",
  bgcolor: "background.paper",
  borderRadius: "5px",
  overflow: "hidden",
};

const NotificationsTable = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const {
    notificatioAddEmailButton,
    editButton,
    editButtonId,
    notificatioEmail,
    notificationActionZone,
    notificationCarFault,
    notificationLowBattery,
    notificationMaxHoles,
    notificationFirstHoleStarted,
    watch,
    notificationAlertSOS,
    enableEmailOnEdit,
    alertEnable,
    disableCross,
    saveEnable,
  } = useHookstate(NOTIFICATION_GLOBAL_STATES);
  const [disabledButton, setDisabledButton] = useState(true);

  // redux state
  const [open, setOpen] = React.useState(false);
  const [testEmail, setTestEmail] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(0);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleClose2 = () => setTestEmail(false);
  const handleDeleteOpen = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const { alertMessageData, getUserRole } =
    useSelector((state) => state.commonReducers) || [];
  const handelDelete = () => {
    const payload = {
      Id: deleteId,
      SiteId: siteId.get(),
      CreateDateInUtc: "2022-07-27T11:27:10.617",
      UpdateDateInUtc: "2022-07-27T11:27:10.617Z",
      UpdatedBy: "VisageMobileProgramming",
      Email: "amrut.pol@mobileprogramming.com",
      AlertsEnabled: true,
      AlertActionZone: true,
      AlertCarFault: true,
      AlertLowBattery: true,
      AlertMaximumHoles: true,
      AlertFirstHoleStarted: true,
      AlertSOS: true,
    };
    dispatch(COMMON_SERVICES.setDeleteEmailApiCall(payload, siteId.get())).then(() => {
      dispatch(COMMON_SERVICES.getAlertMessageServices(siteId.get()));
    });
    handleCloseDelete();
  };
  const handelSendMessage = (Id) => {
    const payload = {
      Id: Id,
      SiteId: siteId.get(),
      CreateDateInUtc: "2022-07-28T12:01:00.507",
      UpdateDateInUtc: "2022-07-28T12:01:00.507Z",
      UpdatedBy: "VisageMobileProgramming",
      Email: "amrut.pol@mobileprogramming.com",
      AlertsEnabled: true,
      AlertActionZone: true,
      AlertCarFault: true,
      AlertLowBattery: true,
      AlertMaximumHoles: true,
      AlertFirstHoleStarted: true,
      AlertSOS: true,
    };

    dispatch(COMMON_SERVICES.sendTestEmailServices(payload)).then(
      setTestEmail(true)
    );
  };
  useEffect(() => {
    dispatch(COMMON_SERVICES.getAlertMessageServices(siteId.get()));
  }, [siteId.get()]);

  // function to handel  edit button

  const handelEditIcon = (
    Id,
    Email,
    AlertActionZone,
    AlertCarFault,
    AlertLowBattery,
    AlertMaximumHoles,
    AlertSOS,
    AlertsEnabled,
    AlertFirstHoleStarted
  ) => {
    editButton.set(Id);
    editButtonId.set(Id);
    notificatioEmail.set(Email);
    notificationActionZone.set(AlertActionZone);
    notificationCarFault.set(AlertCarFault);
    notificationLowBattery.set(AlertLowBattery);
    notificationMaxHoles.set(AlertMaximumHoles);
    notificationFirstHoleStarted.set(AlertFirstHoleStarted);
    notificationAlertSOS.set(AlertSOS);
    disableCross.set(false);
    notificatioAddEmailButton.set(true);
    enableEmailOnEdit.set(true);
    alertEnable.set(AlertsEnabled);
    setDisabledButton(true);
  };
  // reset data fuction
  const resetUsernameData = () => {
    watch.set(watch.get() + 1);
    disableCross.set(true);
    notificatioAddEmailButton.set(false);
    notificatioEmail.set("");
    editButtonId.set(0);
    saveEnable.set(false);
    handleClose();
  };

  // delete data when delete recipient is true
  return (
    <TableContainer>
      <StyledTable>
        <table>
          <tr className="table-head">
            <th>{t("Alerts_Enabled")}</th>
            <th>{t("Email")}</th>

            <th>{t("Action")}</th>
          </tr>
          {alertMessageData.map((item, index) => {
            return (
              <tr className="body">
                <td>
                  <StyledCheckbox className="checkbox">
                    <Checkbox
                      checked={item.AlertsEnabled}
                      checkedIcon={<CheckIcon />}
                      icon={<UnCheckIcon />}
                    />
                  </StyledCheckbox>
                </td>
                <td>{item.Email}</td>
                <td>
                  <div className="action-btn">
                    <Tooltip title={t("Send_Mail")} arrow>
                      <IconButton
                        disabled={
                          isUserBasic(getUserRole && getUserRole?.Role) ||
                          isUserReadOnly(getUserRole && getUserRole?.Role)
                        }
                        onClick={() => handelSendMessage(item.Id)}
                      >
                        <SendMailIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={t("Edit")} arrow>
                      <IconButton
                        onClick={() => {
                          saveEnable.set(false);
                          handelEditIcon(
                            item.Id,
                            item.Email,
                            item.AlertActionZone,
                            item.AlertCarFault,
                            item.AlertLowBattery,
                            item.AlertMaximumHoles,
                            item.AlertSOS,
                            item.AlertsEnabled,
                            item.AlertFirstHoleStarted
                          );
                        }}
                      >
                        <EditIcon color="#0009" width={20.19} height={20.19} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={t("Delete")} arrow>
                      <IconButton
                        disabled={
                          isUserBasic(getUserRole && getUserRole?.Role) ||
                          isUserReadOnly(getUserRole && getUserRole?.Role)
                        }
                        onClick={() => {
                          handleDeleteOpen();
                          setDeleteId(item.Id);
                        }}
                      >
                        <DeleteIcon
                          color="#FA3C30"
                          width={18.19}
                          height={20.19}
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={t("Cancel")} arrow>
                      <IconButton>
                        <CloseIcon
                          disabled={
                            disableCross.get() === true ||
                            isUserBasic(getUserRole && getUserRole?.Role) ||
                            isUserReadOnly(getUserRole && getUserRole?.Role)
                          }
                          onClick={handleOpen}
                          style={{
                            opacity: item?.Id !== editButtonId.get() ? 0.4 : 1,
                            pointerEvents:
                              item?.Id !== editButtonId.get() ? "none" : "auto",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                </td>
              </tr>
            );
          })}
        </table>
      </StyledTable>
      <Modal
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Delete_this_recipient")}?</p>
            <div className="action-btn">
              <button onClick={() => handelDelete()} className="primary">
                {t("Yes")}
              </button>
              <button onClick={() => handleCloseDelete()}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Discard_changes")}?</p>
            <div className="action-btn">
              <button onClick={() => resetUsernameData()} className="primary">
                {t("Yes")}
              </button>
              <button onClick={() => handleClose()}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={testEmail}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <PopUpContainer>
            <h2>{t("Sent")}</h2>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {t("Test_email_sent")}
            </Typography>
            <div className="action-btn">
              <button className="primary" onClick={() => handleClose2()}>
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </TableContainer>
  );
};

export default NotificationsTable;
